import firebase from 'firebase/app'
import 'firebase/firestore'

export const firestore = firebase
    .initializeApp({ projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID })
    .firestore()
